// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseInfoStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { licenseInfoInstance } from './models/Izenda.LicenseInfo';

/**
 * License Info Store
 */
!(function () {
  var m = require('mobx');
  var licenseDataFetcher = require('fetchers/Izenda.LicenseDataFetcher');
  var exportFetcher = require('fetchers/Izenda.ExportFetcher');

  var MESSAGE_TYPE = require('share/messages/Izenda.CommonMessages').MESSAGE_TYPE;
  var CONSTANT = require('logic/data/Izenda.LicenseInfoConstants');
  var LICENSE_NOTIFICATION_MESSAGE_KEY = CONSTANT.LICENSE_NOTIFICATION_MESSAGE_KEY;
  var uiState = require('logic/Izenda.UiState');

  function LicenseInfoStore() {
    this.licenseInfo = licenseInfoInstance;
  }

  /**
   * get license Status
   */
  LicenseInfoStore.prototype.getLicenseStatus = function(){
    var licenseInfo = this.licenseInfo;
    return licenseDataFetcher.getLicenseStatus()
      .then(function (status) {
        licenseInfo.readLicenseStatus(status);
        return status;
      }.bind(this));
  };

  /**
   * Validate license
   * @param {string} licenseKey
   * @param {string} tokenKey
   * @returns {promise}
   */
  LicenseInfoStore.prototype.validateLicense = m.action(function () {
    var tokenKey = this.licenseInfo.licenseOnlineMode ? null : this.licenseInfo.tokenKey;
    return licenseDataFetcher.validateLicense(this.licenseInfo.licenseKey, tokenKey)
      .then(m.action(function (response) {

        this.licenseInfo.readValidateLicense(response);
        uiState.updateLicenseStatus(!!response.expired);
        response.success && this.getLicenseStatus();

        return response.messages;
      }).bind(this));
  });


  /**
   * Get license information
   * @returns {promise}
   */
  LicenseInfoStore.prototype.getLicenseInformation = function () {
    var licenseInfo = this.licenseInfo;
    return this.getLicenseInfo().then(licenseInfo.readLicenseInforation.bind(licenseInfo));
  };

  /**
   * Get license information
   * @returns {promise}
   */
  LicenseInfoStore.prototype.getLicenseInfo = function () {
    return licenseDataFetcher.getLicenseInformation();
  };

  /**
   * export performanceStatisticsTrend
   */
  LicenseInfoStore.prototype.exportPerformanceStatisticsTrend = function () {
    return exportFetcher.exportPerformanceStatisticsTrend();
  };

  /**
   * construtor for create seperate object for test
   * @type {construtor}
   */
  LicenseInfoStore.prototype.LicenseInfoStore = LicenseInfoStore;

  module.exports = exports = new LicenseInfoStore();
}())



// WEBPACK FOOTER //
// ./ui/logic/Izenda.LicenseInfoStore.js